export default function Footer({ text }: { text: string }) {
  return (
    <footer className="bottom-0 left-0 right-0 border-t border-gray-200 px-4 py-2 bg-background shadow-sm text-center z-100">
      <p className="text-xs text-gray-600">{text}</p>
    </footer>
  )
}
